import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'MobileOnlySignIn' */ './MobileOnlySignIn'),
  loading: () => null,
});

export default class SignInLoader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return <LoadableComponent {...this.props} />;
  }
}
